<template>
  <div class="users-main-container"
       v-if="(owner.length || owners.length) && !isYscStemExpo">
    <span class="multiple-avatar-container">
      <span v-if="!$isYSC && !$isIsef">
        <figure v-for="(member,index) in filteredMembers"
                class="avatar-container multiple-avatar"
                :key="index" :data-balloon="getFullName(member.user)"
                data-balloon-pos="down-left"
                :style="{right: index * 0.9 + 'rem' }">
          <img :src="avatar(member.user.avatar)"
               @error="altImg"
               alt="Co-Owner Avatar">
        </figure>
      </span>
      <span v-if="owner && singleUser && !multiUser"
            class="name-container"
            :class="{'name-container_ysc': $isYSC}">
        <h2 :class="{'name-container_title': $isYSC}">
          {{ owner }}
        </h2>
        <p v-if="$isYSC"
           class="name-container_subTitle">
          {{ region }}
        </p>
      </span>
      <span v-if="owner && multiUser && !singleUser && showOwnerName"
            :style="teamAvatarStyleFix"
            class="name-container name-container_owners"
            :class="{
              'name-container_ysc': $isYSC
            }">
        <h2 :class="{'name-container_title': $isYSC}">
          {{ owners }}
        </h2>
        <p v-if="$isYSC"
           class="name-container_subTitle">
          {{ region }}
        </p>
      </span>
    </span>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'
import i18n from '@/i18n'

export default {
  props: ['members', 'project'],
  data: function () {
    return {
      params: { width: 200, height: 200, quality: 10 }
    }
  },
  computed: {
    singleUser: function () {
      return this.members.length < 2
    },
    multiUser: function () {
      return this.members.length > 1
    },
    owner: function () {
      if (!this.members || !this.members[0]) {
        return ''
      }
      const { userName, fullName } = this.members[0].user
      if (!fullName || !this.showOwnerName) {
        return userName
      }
      if (!this.addMobileFix) {
        return fullName
      }
      if (fullName.length > 15) {
        return fullName.slice(0, 15) + '...'
      }
      return fullName
    },
    showOwnerName: function () {
      return this.$isYSC || this.$isOhioScience
    },
    addMobileFix: function () {
      return this.isHomeViewAllFix && this.isPhone && this.showOwnerName
    },
    isYscStemExpo: function () {
      return this.$route.path.includes('stem-expo') && this.$isYSC
    },
    owners: function () {
      return i18n.t('userCard.teamProject')
    },
    filteredMembers: function () {
      return this.members.slice(0, 7)
    },
    region: function () {
      const limitMobile = 16
      const limit = 21
      const region = this.project?.regionProject?.regionDetails?.region
      if (region && this.project) {
        if (this.addMobileFix) {
          if (region.length > limitMobile) {
            return region.slice(0, limitMobile) + '...'
          }
          return region
        } else {
          if (this.isMobile) {
            return region
          }
        }
        if (region.length > limit) return region.slice(0, limit) + '...'
        return region
      } else {
        return ''
      }
    },
    isMobile: function () {
      return (/Android|iPhone|webOS|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    },
    isPhone: function () {
      return (/Android|iPhone/i.test(navigator.userAgent))
    },
    // Route check for mobile card
    isHomeViewAllFix: function () {
      if (this.$route.fullPath.includes('/home')) return true
      if (this.$route.fullPath.includes('/viewAll')) return true
      return false
    },
    teamAvatarStyleFix: function () {
      return this.$isOhioScience ? `margin-left: calc(${this.filteredMembers.length}*-9px)` : ''
    }
  },
  methods: {
    avatar: function (url, params) {
      return imageProxy.projectCardAvatar(url, params)
    },
    altImg: function (e) {
      e.target.src = 'https://www.engineering.com/static/purple-logo-icon.svg'
    },
    getFullName: function (user) {
      if (this.showOwnerName) {
        return user.fullName ? user.fullName : user.userName
      } else {
        return user.userName
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.users-main-container {
  color: #aaaaaa;
  width: 80%;
  padding-left: 0.5rem;
  display: flex;
  min-height: 35px;
  height: 35px;
  font-family: $primary-font;
@include touch {
  padding-left: 0.5rem;
}
span {
  display: flex;
  justify-content: center;
  align-items: center;
}
}
.avatar-container {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  margin-right: 0.5rem;
  z-index: 4;
  overflow: visible;
img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
}
.name-container {
  &_subTitle {
   width: 100%;
   font-size: .7em;
  }
   &_title {
    width: 100%;
    @include mobile {
      max-width: 100% !important;
    }
  }
  h2 {
    font-size: 0.85rem;
    font-weight: 400;
    font-family: $primary-font;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 180px;
  @include mobile {
    max-width: 91px;
    font-size: 0.75rem;
  }
}
&_ysc {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  @include mobile {
    margin-top: 0px;
  }
 }
color: black;
}
.multiple-avatar-container {
.multiple-avatar{
  position: relative;
}
}
</style>
